import { z } from 'zod'

import { type FormEnum } from '#app/routes/_layout/route-config.ts'
import { generateItemFormFetcherKey } from '#app/utils/client/generate-item-form-fetcher-key.ts'
import { schemaDefault } from '#app/utils/form-defaults.ts'

/* -------------------------------------------------------------------------------------------------
 * I18next
 * -----------------------------------------------------------------------------------------------*/

enum I18NEXT {
	routeCart = 'route-cart',
}

/* -------------------------------------------------------------------------------------------------
 * Route loader
 * -----------------------------------------------------------------------------------------------*/

enum ROUTE_LOADER {
	root = 'root',
	current = 'routes/($lang).cart',
}

enum TEST_ID {
	cart = 'cart',
	cartCount = 'cart-count',
	cartEmpty = 'cart-empty',
	cartItems = 'cart-items',
}

/* -------------------------------------------------------------------------------------------------
 * Inputs
 * -----------------------------------------------------------------------------------------------*/

enum INPUTS {
	itemId = 'itemId',
	orderItemId = 'orderItemId',
	quantity = 'quantity',
}

/* -------------------------------------------------------------------------------------------------
 * Set quantity form
 * -----------------------------------------------------------------------------------------------*/

const FORM_SET_QUANTITY: FormEnum = {
	generateId: ({ id }) =>
		generateItemFormFetcherKey('cart-set-quantity-form', id),
	action: '/cart',
	generateFetcherKey: ({ id }) =>
		generateItemFormFetcherKey('set-quantity', id),
	subaction: 'set-quantity',
	redirect: '/cart',
}

const setQuantitySchema = z.object({
	...schemaDefault,
	...{
		[INPUTS.quantity]: z
			.number({
				invalid_type_error: 'validation.quantity.invalidType',
				required_error: 'validation.quantity.required',
			})
			.min(1, 'validation.quantity.min'),
		[INPUTS.orderItemId]: z.string(),
	},
})

/* -------------------------------------------------------------------------------------------------
 * Remove item form
 * -----------------------------------------------------------------------------------------------*/

const FORM_REMOVE_ITEM: FormEnum = {
	generateId: ({ id }) =>
		generateItemFormFetcherKey('cart-remove-item-form', id),
	action: '/cart',
	generateFetcherKey: ({ id }) => generateItemFormFetcherKey('remove-item', id),
	subaction: 'remove-item',
	redirect: '/cart',
}

const removeItemSchema = z.object({
	...schemaDefault,
	...{
		[INPUTS.itemId]: z.string(),
	},
})

/* -------------------------------------------------------------------------------------------------
 * Schema
 * -----------------------------------------------------------------------------------------------*/

const schema = z.object({
	...schemaDefault,
	...{
		[INPUTS.quantity]: z
			.number({
				invalid_type_error: 'validation.quantity.invalidType',
				required_error: 'validation.quantity.required',
			})
			.min(1, 'validation.quantity.min'),
	},
})

/* -----------------------------------------------------------------------------------------------*/

export {
	I18NEXT as CART_I18NEXT,
	ROUTE_LOADER as CART_ROUTE_LOADER,
	TEST_ID as CART_TEST_ID,
	INPUTS as CART_INPUTS,
	FORM_SET_QUANTITY as CART_FORM_SET_QUANTITY,
	FORM_REMOVE_ITEM as CART_FORM_REMOVE_ITEM,
	schema as cartSchema,
	setQuantitySchema as cartSetQuantitySchema,
	removeItemSchema as cartRemoveItemSchema,
}
